import { useEffect } from "react"
import { keycloak } from "../../../lib/keycloak/index.ts"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts"
import { BrightyIcon } from "../../../ui/icons/brightyIcon.tsx"
import { LayoutComponent } from "../../../ui/layout/index.tsx"
import { MenuItems } from "../../../ui/organisms/sidebar/dto.ts"
import { BotChatList } from "./botChatList.tsx"
import { findBrightyChats, getAllTitles } from "./brighty/slice.ts"
import { ChatBotComponent } from "./chatBot.tsx"
import { findChatBot, getAllBotTitles } from "./slice.ts"

export function Brighty() {
    const authState = useAppSelector(state => state.auth)
    const layoutState = useAppSelector(state => state.layout)
    const brightyState = useAppSelector(state => state.brighty)
    const chatState = useAppSelector(state => state.chat)
    const financialAdvisorState = useAppSelector(state => state.financialAdvisor)

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (keycloak.hasRealmRole('financial_advisor'))
            dispatch(findBrightyChats(brightyState.filters))
        else dispatch(findChatBot({ page: 0, page_size: 500, request_user_id: authState.findMeCompanyResponse?.userId!, financial_advisor_user_id: financialAdvisorState.findByIdFinancialAdvisorResponse?.userId! }))
    }, [])

    useEffect(() => {
        if (brightyState.findBrightyChatResponse && Object.keys(brightyState.findBrightyChatResponse.messages).length > 0) {
            dispatch(getAllTitles())
        }
    }, [brightyState.findBrightyChatResponse])

    useEffect(() => {
        if (chatState.findChatBotResponse && Object.keys(chatState.findChatBotResponse.messages).length > 0) {
            dispatch(getAllBotTitles())
        }
    }, [chatState.findChatBotResponse])

    return (
        <>
            {
                keycloak.hasRealmRole("company") || keycloak.hasRealmRole("administrative_company") || keycloak.hasRealmRole('financial_advisor') ?
                    <LayoutComponent
                        menuItem={MenuItems.BRIGHTY}
                        headingLabel={""}
                        headingButtons={[]}
                        breadcrumbItems={["Brighty"]}
                        breadcrumbIcon={<BrightyIcon size={'20'} color={layoutState.theme[500]} />}
                    >
                        <div className="w-full flex flex-row flex-grow " style={{ height: 'calc(100vh - 250px)' }}>
                            <BotChatList />
                            {
                                <ChatBotComponent />
                            }
                        </div>
                    </LayoutComponent>
                    :
                    <div className="w-full flex flex-row flex-grow gap-4" style={{ height: 'calc(100vh - 250px)' }}>
                        <BotChatList />
                        {
                            <ChatBotComponent />
                        }
                    </div>
            }
        </>
    )
}